<script lang="ts">
    // Copy from the node module because the value=string annoys me
    import { createEventDispatcher, onMount } from 'svelte'

    import flatpickr from 'flatpickr'
    import { DateTime } from 'luxon'

    const hooks = new Set(['onChange', 'onOpen', 'onClose', 'onMonthChange', 'onYearChange', 'onReady', 'onValueUpdate', 'onDayCreate'])

    let ready = $state(false)

    interface Props {
        value?: DateTime | Date | string | null
        formattedValue?: string
        element?: string | undefined
        dateFormat?: string | undefined
        options?: any
        input?: HTMLInputElement | undefined
        flatpickr?: any
        isLuxon?: boolean
        children?: import('svelte').Snippet
        [key: string]: any
    }

    let { value = $bindable(), formattedValue = $bindable(''), element, dateFormat, options = {}, input = $bindable(), flatpickr: fp = $bindable(), isLuxon = Boolean(value && (value as any).isLuxonDateTime === true), children, ...rest }: Props = $props()

    onMount(() => {
        const elem: any = element || input

        const opts: any = addHooks(options)
        opts.onReady.push(() => {
            ready = true
        })

        fp = flatpickr(elem, Object.assign(opts, element ? { wrap: true } : {}))

        return () => {
            fp.destroy()
        }
    })

    const dispatch = createEventDispatcher()

    function addHooks(opts: any = {}) {
        opts = Object.assign({}, opts)

        for (const hook of hooks) {
            const firer = (selectedDates, dateStr, instance) => {
                dispatch(stripOn(hook), [selectedDates, dateStr, instance])
            }

            if (hook in opts) {
                // Hooks must be arrays
                if (!Array.isArray(opts[hook])) opts[hook] = [opts[hook]]

                opts[hook].push(firer)
            } else {
                opts[hook] = [firer]
            }
        }

        if (opts.onChange && !opts.onChange.includes(updateValue)) opts.onChange.push(updateValue)

        return opts
    }

    function updateValue(newValue, dateStr, fp) {
        const mode = fp?.config?.mode ?? 'single'

        const localValue = mode === 'single' ? newValue[0] : newValue
        value = isLuxon ? DateTime.fromJSDate(localValue) : localValue
        formattedValue = dateStr
    }

    function stripOn(hook) {
        return hook.charAt(2).toLowerCase() + hook.substring(3)
    }
    $effect(() => {
        if (fp && ready) {
            fp.setDate(isLuxon && value ? (value as DateTime).toJSDate() : value, false, dateFormat)
        }
    })
    $effect(() => {
        if (fp && ready) {
            for (const [key, val] of Object.entries(addHooks(options))) {
                fp.set(key, val)
            }
        }
    })
</script>

{#if children}{@render children()}{:else}
    <input bind:this={input} {...rest} />
{/if}
